export default __webpack_public_path__ + "static/media/quiz.bd54b6ef.png";